import Api from '../api/api'
import * as types from './mutation-types'

// get logined user info
export const getUserInfo = ({commit}, params) => {
  return Api.getUserInfo(params).then(response => {
    commit(types.USER_INFO, response.data)
    return response
  })
}
// get user
export const getUser = ({commit}, params) => {
  return Api.getUser(params).then(response => {
    return response
  })
}
// get search user
export const getSearchUser = ({commit}, params) => {
  return Api.getSearchUser(params).then(response => {
    return response
  })
}
// createUser
export const createUser = ({commit}, params) => {
  return Api.createUser(params).then(response => {
    return response
  })
}
// updateUser
export const updateUser = ({commit}, params) => {
  return Api.updateUser(params).then(response => {
    return response
  })
}
// resetUserPwd
export const resetUserPwd = ({commit}, params) => {
  return Api.resetUserPwd(params).then(response => {
    return response
  })
}
// unlockUser
export const unlockUser = ({commit}, params) => {
  return Api.unlockUser(params).then(response => {
    return response
  })
}
// cleanUser
export const cleanUser = ({commit}, params) => {
  return Api.cleanUser(params).then(response => {
    return response
  })
}
// login
export const login = ({commit}, params) => {
  return Api.login(params).then(response => {
    return response
  })
}
// change password
export const changePassword = ({commit}, params) => {
  return Api.changePassword(params).then(response => {
    return response
  })
}
// update profile
export const updateProfile = ({commit}, params) => {
  return Api.updateProfile(params).then(response => {
    return response
  })
}
// logout
export const logout = ({commit}, params) => {
  return Api.logout(params).then(response => {
    return response
  })
}
// create news
export const createNews = ({commit}, params) => {
  return Api.createNews(params).then(response => {
    return response
  })
}
// create chain
export const createChain = ({commit}, params) => {
  return Api.createChain(params).then(response => {
    return response
  })
}
// update chain
export const updateChain = ({commit}, params) => {
  return Api.updateChain(params).then(response => {
    return response
  })
}
// del chain
export const delChain = ({commit}, params) => {
  return Api.delChain(params).then(response => {
    return response
  })
}
// del plans
export const delPlans = ({commit}, params) => {
  return Api.delPlans(params).then(response => {
    return response
  })
}
// update news
export const updateNews = ({commit}, params) => {
  return Api.updateNews(params).then(response => {
    return response
  })
}
// pub news
export const pubNews = ({commit}, params) => {
  return Api.pubNews(params).then(response => {
    return response
  })
}
// revoke news
export const revokeNews = ({commit}, params) => {
  return Api.revokeNews(params).then(response => {
    return response
  })
}

export const deleteNews = ({commit}, params) => {
  return Api.deleteNews(params).then(response => {
    return response
  })
}
// update newsweight
export const updateNewsWeight = ({commit}, params) => {
  return Api.updateNewsWeight(params).then(response => {
    return response
  })
}
export const updateNewsAuditStatus = ({commit}, params) => {
  return Api.updateNewsAuditStatus(params).then(response => {
    return response
  })
}
export const updateNewsVoteNums = ({commit}, params) => {
  return Api.updateNewsVoteNums(params).then(response => {
    return response
  })
}
// search signs
export const getNewsSignsByKey = ({commit}, params) => {
  return Api.getNewsSignsByKey(params).then(response => {
    return response
  })
}
// create signature
export const createSignature = ({commit}, params) => {
  return Api.createSignature(params).then(response => {
    return response
  })
}
// update signature
export const updateSignature = ({commit}, params) => {
  return Api.updateSignature(params).then(response => {
    return response
  })
}
// get signatures
export const getSignatures = ({commit}, params) => {
  return Api.getSignatures(params).then(response => {
    return response
  })
}
// get signature
export const getSignature = ({commit}, params) => {
  return Api.getSignature(params).then(response => {
    return response
  })
}
// create relate
export const createRelate = ({commit}, params) => {
  return Api.createRelate(params).then(response => {
    return response
  })
}
// delete relate
export const delRelate = ({commit}, params) => {
  return Api.delRelate(params).then(response => {
    return response
  })
}
// update NewsRelate Weight
export const updateNewsRelateWeight = ({commit}, params) => {
  return Api.updateNewsRelateWeight(params).then(response => {
    return response
  })
}
// get search relate news
export const getSearchRelateNews = ({commit}, params) => {
  return Api.getSearchRelateNews(params).then(response => {
    return response
  })
}
// get relate news
export const getRelateNews = ({commit}, params) => {
  return Api.getRelateNews(params).then(response => {
    return response
  })
}
// create news plan
export const createNewsPlan = ({commit}, params) => {
  return Api.createNewsPlan(params).then(response => {
    return response
  })
}
// create news vote
export const createNewsVote = ({commit}, params) => {
  return Api.createNewsVote(params).then(response => {
    return response
  })
}
// update news vote
export const updateNewsVote = ({commit}, params) => {
  return Api.updateNewsVote(params).then(response => {
    return response
  })
}
// push url to cdn
export const pushUrlToCdn = ({commit}, params) => {
  return Api.pushUrlToCdn(params).then(response => {
    return response
  })
}
// push solr
export const pushSolr = ({commit}, params) => {
  return Api.pushSolr(params).then(response => {
    return response
  })
}
// upload
export const upload = ({commit}, params) => {
  return Api.upload(params).then(response => {
    return response
  })
}
// get news votes
export const getNewsVotes = ({commit}, params) => {
  return Api.getNewsVotes(params).then(response => {
    return response
  })
}
// get news vote
export const getNewsVote = ({commit}, params) => {
  return Api.getNewsVote(params).then(response => {
    return response
  })
}
// create channel
export const createChannel = ({commit}, params) => {
  return Api.createChannel(params).then(response => {
    return response
  })
}
// update channel
export const updateChannel = ({commit}, params) => {
  return Api.updateChannel(params).then(response => {
    return response
  })
}
// get channel
export const getChannel = ({commit}, params) => {
  return Api.getChannel(params).then(response => {
    commit(types.CURRENT_CHANNEL, response.data)
    return response
  })
}
// get channels
export const getChannels = ({commit}, params) => {
  return Api.getChannels(params).then(response => {
    if (params.all !== 1) {
      commit(types.CHANNEL_LIST, response.data)
    }
    return response
  })
}
// get newslist
export const getNewsList = ({commit}, params) => {
  return Api.getNewsList(params).then(response => {
    commit(types.NEWS_LIST, response.data)
    return response
  })
}
// get plans newslist
export const getPlansNewsList = ({commit}, params) => {
  return Api.getPlansNewsList(params).then(response => {
    return response
  })
}
// get revoke newslist
export const getRevokeNewsList = ({commit}, params) => {
  return Api.getRevokeNewsList(params).then(response => {
    return response
  })
}
// get search news
export const getSearchNews = ({commit}, params) => {
  return Api.getSearchNews(params).then(response => {
    return response
  })
}
// get news
export const getNews = ({commit}, params) => {
  return Api.getNews(params).then(response => {
    commit(types.CURRENT_NEWS, response.data)
    return response
  })
}
// get news logs
export const getNewsLogs = ({commit}, params) => {
  return Api.getNewsLogs(params).then(response => {
    return response
  })
}
// get AutoKeyword
export const getAutoKeyword = ({commit}, params) => {
  return Api.getAutoKeyword(params).then(response => {
    return response
  })
}
// create NewsSignature
export const createNewsSignature = ({commit}, params) => {
  return Api.createNewsSignature(params).then(response => {
    return response
  })
}
// del NewsSignature
export const delNewsSignature = ({commit}, params) => {
  return Api.delNewsSignature(params).then(response => {
    return response
  })
}
// get apps
export const getApps = ({commit}, params) => {
  return Api.getApps(params).then(response => {
    return response
  })
}
// get app
export const getApp = ({commit}, params) => {
  return Api.getApp(params).then(response => {
    return response
  })
}
// createApp
export const createApp = ({commit}, params) => {
  return Api.createApp(params).then(response => {
    return response
  })
}
// updateApp
export const updateApp = ({commit}, params) => {
  return Api.updateApp(params).then(response => {
    return response
  })
}
// getSearchReg
export const getSearchReg = ({commit}, params) => {
  return Api.getSearchReg(params).then(response => {
    return response
  })
}
// getReg
export const getReg = ({commit}, params) => {
  return Api.getReg(params).then(response => {
    return response
  })
}
// createReg
export const createReg = ({commit}, params) => {
  return Api.createReg(params).then(response => {
    return response
  })
}
// resetRegPwd
export const adminUpdateRegPwd = ({commit}, params) => {
  return Api.adminUpdateRegPwd(params).then(response => {
    return response
  })
}
// updateRegStatus
export const updateRegStatus = ({commit}, params) => {
  return Api.updateRegStatus(params).then(response => {
    return response
  })
}
export const createCourseCategory = ({commit}, params) => {
  return Api.createCourseCategory(params).then(response => {
    return response
  })
}
export const updateCourseCategory = ({commit}, params) => {
  return Api.updateCourseCategory(params).then(response => {
    return response
  })
}
export const getCourseCategory = ({commit}, params) => {
  return Api.getCourseCategory(params).then(response => {
    return response
  })
}
export const getCourseCategoryList = ({commit}, params) => {
  return Api.getCourseCategoryList(params).then(response => {
    return response
  })
}
export const createCourse = ({commit}, params) => {
  return Api.createCourse(params).then(response => {
    return response
  })
}
export const updateCourse = ({commit}, params) => {
  return Api.updateCourse(params).then(response => {
    return response
  })
}
export const getCourse = ({commit}, params) => {
  return Api.getCourse(params).then(response => {
    return response
  })
}
export const getCourseList = ({commit}, params) => {
  return Api.getCourseList(params).then(response => {
    return response
  })
}
export const updateCourseStatus = ({commit}, params) => {
  return Api.updateCourseStatus(params).then(response => {
    return response
  })
}
export const updateCourseIsBest = ({commit}, params) => {
  return Api.updateCourseIsBest(params).then(response => {
    return response
  })
}
export const updateCourseChapter = ({commit}, params) => {
  return Api.updateCourseChapter(params).then(response => {
    return response
  })
}
export const getCourseChapter = ({commit}, params) => {
  return Api.getCourseChapter(params).then(response => {
    return response
  })
}
export const getCourseChapterList = ({commit}, params) => {
  return Api.getCourseChapterList(params).then(response => {
    return response
  })
}
export const updateCourseChapterStatus = ({commit}, params) => {
  return Api.updateCourseChapterStatus(params).then(response => {
    return response
  })
}
export const createCourseFile = ({commit}, params) => {
  return Api.createCourseFile(params).then(response => {
    return response
  })
}
export const updateCourseFile = ({commit}, params) => {
  return Api.updateCourseFile(params).then(response => {
    return response
  })
}
export const getCourseFile = ({commit}, params) => {
  return Api.getCourseFile(params).then(response => {
    return response
  })
}
export const getCourseFileList = ({commit}, params) => {
  return Api.getCourseFileList(params).then(response => {
    return response
  })
}
export const updateCourseFileStatus = ({commit}, params) => {
  return Api.updateCourseFileStatus(params).then(response => {
    return response
  })
}
export const createCourseComment = ({commit}, params) => {
  return Api.createCourseComment(params).then(response => {
    return response
  })
}
export const updateCourseComment = ({commit}, params) => {
  return Api.updateCourseComment(params).then(response => {
    return response
  })
}
export const getCourseComment = ({commit}, params) => {
  return Api.getCourseComment(params).then(response => {
    return response
  })
}
export const getCourseCommentList = ({commit}, params) => {
  return Api.getCourseCommentList(params).then(response => {
    return response
  })
}
export const updateCourseCommentStatus = ({commit}, params) => {
  return Api.updateCourseCommentStatus(params).then(response => {
    return response
  })
}
export const getCourseQuestion = ({commit}, params) => {
  return Api.getCourseQuestion(params).then(response => {
    return response
  })
}
export const getCourseQuestionList = ({commit}, params) => {
  return Api.getCourseQuestionList(params).then(response => {
    return response
  })
}
export const replyCourseQuestion = ({commit}, params) => {
  return Api.replyCourseQuestion(params).then(response => {
    return response
  })
}
export const createCourseTask = ({commit}, params) => {
  return Api.createCourseTask(params).then(response => {
    return response
  })
}
export const updateCourseTask = ({commit}, params) => {
  return Api.updateCourseTask(params).then(response => {
    return response
  })
}
export const getCourseTask = ({commit}, params) => {
  return Api.getCourseTask(params).then(response => {
    return response
  })
}
export const getCourseTaskList = ({commit}, params) => {
  return Api.getCourseTaskList(params).then(response => {
    return response
  })
}
export const updateCourseTaskStatus = ({commit}, params) => {
  return Api.updateCourseTaskStatus(params).then(response => {
    return response
  })
}
export const getCourseStudy = ({commit}, params) => {
  return Api.getCourseStudy(params).then(response => {
    return response
  })
}
export const getCourseStudyList = ({commit}, params) => {
  return Api.getCourseStudyList(params).then(response => {
    return response
  })
}
export const updateCourseStudyStatus = ({commit}, params) => {
  return Api.updateCourseStudyStatus(params).then(response => {
    return response
  })
}
export const getCourseStudyTask = ({commit}, params) => {
  return Api.getCourseStudyTask(params).then(response => {
    return response
  })
}
export const getCourseStudyTaskList = ({commit}, params) => {
  return Api.getCourseStudyTaskList(params).then(response => {
    return response
  })
}
export const updateCourseStudyTaskStatus = ({commit}, params) => {
  return Api.updateCourseStudyTaskStatus(params).then(response => {
    return response
  })
}
export const updateQuestion = ({commit}, params) => {
  return Api.updateQuestion(params).then(response => {
    return response
  })
}
export const getQuestion = ({commit}, params) => {
  return Api.getQuestion(params).then(response => {
    return response
  })
}
export const getQuestionList = ({commit}, params) => {
  return Api.getQuestionList(params).then(response => {
    return response
  })
}
export const updateQuestionStatus = ({commit}, params) => {
  return Api.updateQuestionStatus(params).then(response => {
    return response
  })
}
export const updateQuestionWeight = ({commit}, params) => {
  return Api.updateQuestionWeight(params).then(response => {
    return response
  })
}
export const delQuestion = ({commit}, params) => {
  return Api.delQuestion(params).then(response => {
    return response
  })
}
export const aiGenerateQuestion = ({commit}, params) => {
  return Api.aiGenerateQuestion(params).then(response => {
    return response
  })
}
export const saveAIQuestion = ({commit}, params) => {
  return Api.saveAIQuestion(params).then(response => {
    return response
  })
}
export const createQuestionBankCategory = ({commit}, params) => {
  return Api.createQuestionBankCategory(params).then(response => {
    return response
  })
}
export const updateQuestionBankCategory = ({commit}, params) => {
  return Api.updateQuestionBankCategory(params).then(response => {
    return response
  })
}
export const getQuestionBankCategory = ({commit}, params) => {
  return Api.getQuestionBankCategory(params).then(response => {
    return response
  })
}
export const getQuestionBankCategoryList = ({commit}, params) => {
  return Api.getQuestionBankCategoryList(params).then(response => {
    return response
  })
}
export const updateQuestionBank = ({commit}, params) => {
  return Api.updateQuestionBank(params).then(response => {
    return response
  })
}
export const getQuestionBank = ({commit}, params) => {
  return Api.getQuestionBank(params).then(response => {
    return response
  })
}
export const getQuestionBankList = ({commit}, params) => {
  return Api.getQuestionBankList(params).then(response => {
    return response
  })
}
export const updateQuestionBankStatus = ({commit}, params) => {
  return Api.updateQuestionBankStatus(params).then(response => {
    return response
  })
}
export const getQuestionBankStudy = ({commit}, params) => {
  return Api.getQuestionBankStudy(params).then(response => {
    return response
  })
}
export const getQuestionBankStudyList = ({commit}, params) => {
  return Api.getQuestionBankStudyList(params).then(response => {
    return response
  })
}
export const updateQuestionBankStudyStatus = ({commit}, params) => {
  return Api.updateQuestionBankStudyStatus(params).then(response => {
    return response
  })
}
export const getQuestionTotalScore = ({commit}, params) => {
  return Api.getQuestionTotalScore(params).then(response => {
    return response
  })
}
export const getQuestionTotalScoreList = ({commit}, params) => {
  return Api.getQuestionTotalScoreList(params).then(response => {
    return response
  })
}
export const getQuestionCorrection = ({commit}, params) => {
  return Api.getQuestionCorrection(params).then(response => {
    return response
  })
}
export const getQuestionCorrectionList = ({commit}, params) => {
  return Api.getQuestionCorrectionList(params).then(response => {
    return response
  })
}
export const updateQuestionCorrection = ({commit}, params) => {
  return Api.updateQuestionCorrection(params).then(response => {
    return response
  })
}
export const delQuestionCorrection = ({commit}, params) => {
  return Api.delQuestionCorrection(params).then(response => {
    return response
  })
}
export const updateExam = ({commit}, params) => {
  return Api.updateExam(params).then(response => {
    return response
  })
}
export const getExam = ({commit}, params) => {
  return Api.getExam(params).then(response => {
    return response
  })
}
export const getExamList = ({commit}, params) => {
  return Api.getExamList(params).then(response => {
    return response
  })
}
export const updateExamStatus = ({commit}, params) => {
  return Api.updateExamStatus(params).then(response => {
    return response
  })
}
export const updateExamType = ({commit}, params) => {
  return Api.updateExamType(params).then(response => {
    return response
  })
}
export const delExamType = ({commit}, params) => {
  return Api.delExamType(params).then(response => {
    return response
  })
}
export const updateExamTypeWeight = ({commit}, params) => {
  return Api.updateExamTypeWeight(params).then(response => {
    return response
  })
}
export const getExamType = ({commit}, params) => {
  return Api.getExam(params).then(response => {
    return response
  })
}
export const getExamTypeList = ({commit}, params) => {
  return Api.getExamTypeList(params).then(response => {
    return response
  })
}
export const updateExamQuestion = ({commit}, params) => {
  return Api.updateExamQuestion(params).then(response => {
    return response
  })
}
export const delExamQuestion = ({commit}, params) => {
  return Api.delExamQuestion(params).then(response => {
    return response
  })
}
export const updateExamQuestionScore = ({commit}, params) => {
  return Api.updateExamQuestionScore(params).then(response => {
    return response
  })
}
export const updateExamQuestionWeight = ({commit}, params) => {
  return Api.updateExamQuestionWeight(params).then(response => {
    return response
  })
}
export const getExamQuestion = ({commit}, params) => {
  return Api.getExamQuestion(params).then(response => {
    return response
  })
}
export const getExamQuestionList = ({commit}, params) => {
  return Api.getExamQuestionList(params).then(response => {
    return response
  })
}
export const getRegOrderList = ({commit}, params) => {
  return Api.getRegOrderList(params).then(response => {
    return response
  })
}
export const getRegOrder = ({commit}, params) => {
  return Api.getRegOrder(params).then(response => {
    return response
  })
}
export const closeRegOrder = ({commit}, params) => {
  return Api.closeRegOrder(params).then(response => {
    return response
  })
}
export const getScorePackageList = ({commit}, params) => {
  return Api.getScorePackageList(params).then(response => {
    return response
  })
}
export const getScorePackage = ({commit}, params) => {
  return Api.getScorePackage(params).then(response => {
    return response
  })
}
export const createScorePackage = ({commit}, params) => {
  return Api.createScorePackage(params).then(response => {
    return response
  })
}
export const updateScorePackage = ({commit}, params) => {
  return Api.updateScorePackage(params).then(response => {
    return response
  })
}
export const updateScorePackageStatus = ({commit}, params) => {
  return Api.updateScorePackageStatus(params).then(response => {
    return response
  })
}
